import { FlexDiv } from '@/app/shared/common.StyledComponents';
import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';
import { DropdownProps } from './UserProfile.types';

// Base typography styles shared across interactive elements
const baseTypographyStyles = `
  font-family: ${({ theme }: any) => theme.typography.fontFamilies.primary};
  font-size: ${rem(14)};
`;

// Common interactive element base styles
const interactiveElementBaseStyles = `
  ${baseTypographyStyles}
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: ${rem(4)};
`;

export const UserProfileContainer = styled(FlexDiv)`
  position: relative;
  align-items: center;
  height: 100%;
  margin-left: auto;
  padding: 0 ${rem(24)};
`;

export const UserButton = styled.button<{ selected?: boolean }>`
  ${interactiveElementBaseStyles}
  :focus-visible {
    outline: ${({ theme }: any) =>
      `${rem(1)} solid ${theme.colors.accessibility.focused}`};
  }
  :hover {
    outline: ${({ theme }: any) =>
      `${rem(1)} solid ${theme.colors.greyscale.white}`};
  }
  gap: ${rem(8)};
  border: none;
  padding: ${rem(8)} ${rem(12)};
  font-weight: ${({ theme }: any) => theme.typography.fontWeights.medium};
  background: ${({ theme }: any) => theme.colors.background};
  color: ${({ theme }: any) => theme.colors.greyscale.white};

  svg {
    fill: ${({ selected, theme }: any) =>
      selected ? theme.colors.background : theme.colors.greyscale.white};
    flex-shrink: 0;
  }
`;

export const Username = styled.span`
  color: ${({ theme }: any) => theme.colors.greyscale.white};
  font-weight: ${({ theme }: any) => theme.typography.fontWeights.medium};
`;

export const DropdownMenu = styled.div<DropdownProps>`
  position: absolute;
  top: 100%;
  right: 0;
  border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray10};
  border-radius: ${rem(4)};
  box-shadow: 0 ${rem(4)} ${rem(12)} rgba(0, 0, 0, 0.15);
  min-width: ${rem(120)};
  z-index: 1000;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0)' : 'translateY(-8px)')};
  margin-top: ${rem(4)};
`;

export const DropdownItem = styled.button<{ selected?: boolean }>`
  ${interactiveElementBaseStyles}
  :focus-visible {
    outline: ${({ theme }: any) =>
      `${rem(1)} solid ${theme.colors.accessibility.focused}`};
  }
  :hover {
    outline: ${({ theme }: any) =>
      `${rem(1)} solid ${theme.colors.greyscale.white}`};
  }
  width: 100%;
  padding: ${rem(12)} ${rem(16)};
  height: ${rem(40)};
  border: ${rem(1)};
  font-weight: ${({ theme }: any) => theme.typography.fontWeights.regular};
  background: ${({ theme }: any) => theme.colors.background};
  color: ${({ theme }: any) => theme.colors.greyscale.white};

  svg {
    fill: ${({ theme }: any) => theme.colors.greyscale.white};
    flex-shrink: 0;
  }

  :active {
    background: ${({ theme }: any) => theme.colors.navigation.active};

    h4 {
      color: ${({ theme }: any) => theme.colors.navigation.textActive};
    }

    svg {
      fill: ${({ theme }: any) => theme.colors.navigation.textActive};
    }
  }
`;
